import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"
import useWindowSize from "../../Shared/Hooks/useWindowSize"
import { AlertCircleIcon, InviteUserIcon } from "../../Shared/Components/SvgIcons"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import HTTPService from "../../../App/HTTPService"
import { headers } from "../../../App/Axios"
import { RoleType } from "../../../App/enums"
import RoomFilterDropdown from "../../Shared/Components/RoomFilterDropdown"

function OrganizationDashboardButtons() {
    const translation = useSelector(selectTranslations)
    const [invitationNumber, setInvitationNumber] = useState(0)
    const windowSize = useWindowSize()
    const breakpoint = 1280
    const { id } = useParams()
    const navigate = useNavigate()

    const getInvitationRequest = useCallback(() => {
        return HTTPService.get(`/org/invitations/${id}`, headers)
    }, [id])

    useEffect(() => {
        getInvitationRequest().then(response => {
            if (response.status === 200) {
                setInvitationNumber(response.data.length)
            }
        })
    }, [getInvitationRequest])

    const onInvitationClick = () => {
        navigate(`/invitations/${id}`)
    }

    return (
        <div className="organization-dashboard-feed__button-container">
            {translation.newPostsInMyRooms}
            <div className="organization-dashboard-feed__button-container organization-dashboard-feed__button-container--width">
                {" "}
                <RoomFilterDropdown type={RoleType.ORGANIZATION} />
                {invitationNumber > 0 && (
                    <button className="dashboard-feed__button dashboard-feed__button--organization" onClick={onInvitationClick}>
                        {invitationNumber > 0 && invitationNumber + " "}
                        {windowSize > breakpoint ? invitationNumber === 1 ? translation.Invitation : translation.Invitations : <InviteUserIcon color="white" />}
                        {invitationNumber > 0 && <AlertCircleIcon />}
                    </button>
                )}
            </div>
        </div>
    )
}

export default OrganizationDashboardButtons
